<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0">
                            <svg width="36" height="33" viewBox="0 0 36 33" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_667_1492)">
                                    <path
                                        d="M14.812 15.7043H12.8784C12.6021 15.7043 12.4794 16.0437 12.6635 16.2289L13.1239 16.6917L11.9883 20.1473L12.3566 24.1891H15.2724L15.6715 20.1473L14.6279 16.6917L15.0576 16.2289C15.2111 16.0437 15.0883 15.7043 14.812 15.7043Z"
                                        fill="#265D91" />
                                    <path
                                        d="M4.62172 18.7588C4.62172 18.7588 4.19202 22.0602 4.00786 23.5103C3.94647 23.8805 4.25341 24.1891 4.62172 24.1891H11.2514L10.8524 19.9313L11.6504 17.8641V14.933L5.32766 17.8332C4.95935 17.9875 4.7138 18.3269 4.62172 18.7588Z"
                                        fill="#265D91" />
                                    <path
                                        d="M23.6191 23.5104C23.435 22.0603 23.0053 18.7589 23.0053 18.7589C22.9132 18.327 22.6677 17.9876 22.2993 17.8025L15.9766 14.9022V17.679L16.7746 19.9622L16.3449 24.1891H23.0053C23.3736 24.22 23.6498 23.8806 23.6191 23.5104Z"
                                        fill="#265D91" />
                                    <path
                                        d="M18.1284 10.0582C18.3126 9.13258 18.1591 8.33039 17.7601 8.26868C17.8829 7.31222 17.8829 5.98551 17.2997 5.30674C17.1769 5.15247 17.0235 5.05991 16.87 4.96735C16.7472 4.75137 16.5324 4.35028 16.1027 4.01089C15.4888 3.48637 14.6908 3.23955 13.8314 3.36296C12.9413 3.2704 12.174 3.48637 11.5601 4.01089C11.1304 4.35028 10.9155 4.78223 10.7928 4.96735C10.6393 5.05991 10.4858 5.15247 10.3631 5.30674C9.77989 5.98551 9.81059 7.31222 9.90267 8.26868C9.50366 8.36124 9.35019 9.16343 9.53435 10.0582C9.71851 10.9221 10.1789 11.6009 10.5779 11.57C10.9155 12.7733 11.8977 14.5011 13.8314 14.532C15.7957 14.5011 16.7779 12.7733 17.0848 11.57C17.4839 11.57 17.9443 10.9221 18.1284 10.0582Z"
                                        fill="#265D91" />
                                    <path
                                        d="M26.4461 11.1381H20.6758C20.461 11.1381 20.2461 11.0147 20.1233 10.8296C20.0006 10.6445 20.0006 10.3977 20.1233 10.1817L21.3817 7.86766C21.0748 7.15803 20.8907 6.35584 20.8907 5.5845C20.8907 2.49914 23.3768 0 26.4461 0C29.5154 0 32.0016 2.49914 32.0016 5.5845C32.0016 8.639 29.4847 11.1381 26.4461 11.1381ZM21.7808 9.84229H26.4461C28.7788 9.84229 30.7124 7.92937 30.7124 5.55364C30.7124 3.17792 28.7788 1.29585 26.4461 1.29585C24.1134 1.29585 22.1798 3.20877 22.1798 5.5845C22.1798 6.29413 22.3639 6.97291 22.6709 7.58998C22.7629 7.7751 22.7629 8.02193 22.6709 8.20705L21.7808 9.84229Z"
                                        fill="#265D91" />
                                    <path
                                        d="M28.776 5.06002L27.8245 5.98562L28.1007 7.25062C28.1314 7.37403 28.07 7.49745 27.9779 7.55916C27.9166 7.59001 27.8552 7.62086 27.7938 7.62086C27.7324 7.62086 27.7017 7.62086 27.6403 7.59001L26.474 6.94208L25.3077 7.59001C25.2156 7.65172 25.0928 7.65172 25.0007 7.55916C24.9086 7.49745 24.8473 7.37403 24.8779 7.25062L25.1542 5.98562L24.2027 5.06002C24.1106 4.96746 24.0799 4.84404 24.1413 4.72063C24.2027 4.59721 24.2948 4.5355 24.4176 4.5355H25.5839L26.2284 3.42478C26.2898 3.33221 26.3819 3.27051 26.474 3.27051C26.5354 3.27051 26.5661 3.27051 26.6275 3.30136C26.6581 3.33222 26.7195 3.36307 26.7502 3.42478L27.3948 4.5355H28.5611C28.6839 4.5355 28.776 4.59721 28.8374 4.72063C28.868 4.84404 28.868 4.96746 28.776 5.06002Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_667_1492" x="0" y="0" width="36" height="32.1912"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_667_1492" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_667_1492"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                           Modifier client
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="/nos-clients/liste">
                                Nos clients</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Modifier client</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container-content">
                         <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section_title">
                                <h1 class="section-heading">Modifier client</h1>
                            </div>
                        </div>
                        <form [formGroup]="formclient">
                            
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-sm-6 mb-5 tools">
                                       <label for="nom" class="required form-label">Nom</label>
                            <input type="text" name="nom" id="nom" class="form-control mb-3 cursor-not-allowed" formControlName="name"
                            placeholder="Nom complet" [readonly]="true">
                        <div *ngIf="formclient.get('name')?.hasError('required') && formclient.get('name')?.touched"
                            class="text-danger">
                            Le champ "name" est obligatoire.
                        </div>
                        <div *ngIf="clientSearchErrorMessage" class="text-danger">
                            <!-- {{ clientSearchErrorMessage }} -->
                            client déjà associé à cette entreprise
                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools year_of_creation">
                                        <label for="year_of_creation">Année de création</label>
                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px','pointer-events':'none'}" view="year" dateFormat="yy"
                        placeholder="Année" inputId="yearpicker" formControlName="year_of_creation" class="form-control mb-3 cursor-not-allowed" [maxDate]="today"
                        (input)="onInput($event)" [disabled]="isDisabled"></p-calendar>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="linkedin_link"> LinkedIn </label>
                                      <input type="text" name="linkedin_link" id="linkedin_link" class="form-control mb-3 cursor-not-allowed"
                             formControlName="linkedin_link"
                            placeholder="LinkedIn" [readonly]="true">
                        <div *ngIf="formclient.get('linkedin_link')?.hasError('required') && formclient.get('linkedin_link')?.touched"
                            class="text-danger" >
                            Le champ "Lien LinkedIn" est obligatoire.
                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom"> Site Web </label>
                                          <input type="text" name="website_link" id="website_link" class="form-control mb-3 cursor-not-allowed"
                             formControlName="website_link" placeholder="Site Web" [readonly]="true">
                        <div *ngIf="formclient.get('website_link')?.hasError('required') && formclient.get('website_link')?.touched"
                            class="text-danger">
                            Le champ "Lien website_link" est obligatoire.
                        </div>
                        <!-- <span class="requirements mt-5"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_379_198)">
                              <path
                                d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                                fill="#2b5d8f" />
                            </g>
                            <defs>
                              <clipPath id="clip0_379_198">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
    
                            </svg>
                            &nbsp;Au moins l'un des champs Site web ou LinkedIn est requis.
                        </span> -->
                                    
                                    </div>
                                    
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">Pays</label>
                                        <!-- <input type="text" name="nom" id="nom" class="form-control mb-3" placeholder="Pays"> -->
                                        <ng-select [notFoundText]="'Aucun élément trouvé'" class="form-control mb-3 cursor-not-allowed"
                            formControlName="country" [placeholder]="'Pays'" [readonly]="true" autoComplete>
                        </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">Ville</label>
                                        <!-- <input type="text" name="nom" id="nom" class="form-control mb-3" placeholder="Location"> -->
                                     <ng-select formControlName="city" [items]="stateList" [readonly]="true"
                                                [ngClass]="{'disable-select cursor-not-allowed':!stateList?.length}"
                                                [attr.disabled]="!stateList?.length ? true : null"
                                                [placeholder]="'Ville'" [notFoundText]="'Aucun élément trouvé'"
                                                autoComplete [multiple]="true" bindLabel="name" bindValue="name"
                                                [notFoundText]="'Aucun élément trouvé'">
                                            </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">Nom vis à vis</label>
                                       <input type="text" name="related_first_name_ESN" id="Prenom"
                                            class="form-control mb-3" placeholder="Prenom vis à vis"
                                            formControlName="related_first_name_ESN">
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">Prénom vis à vis</label>
                                       
                                              <input type="text" name="related_last_name_ESN" id="nom"
                                            class="form-control mb-3" placeholder="Nom vis à vis"
                                            formControlName="related_last_name_ESN">
                                    </div>
                                    
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="Email" class="required form-label">Mail vis à vis</label>
                                        <input type="email" name="Email" id="Email" class="form-control mb-3 cursor-not-allowed" [readonly]="true"
                                            placeholder="Mail vis à vis" formControlName="related_email_ESN">

                                        <div *ngIf="formclient.get('related_email_ESN')?.hasError('pattern') && formclient.get('related_email_ESN')?.touched"
                                            class="text-danger">
                                            La valeur de ce champ doit avoir une adresse email valide.
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="tel">num vis à vis</label>
                                        <div class="wrapper  ">
                                            <ngx-intl-tel-input [cssClass]="'form-control'"
                                                [searchCountryPlaceholder]="'Rechercher un pays'"
                                                [preferredCountries]="preferredCountries"
                                                [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                                [searchCountryFlag]="true"
                                                [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                                                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France"
                                                [maxLength]="20" [phoneValidation]="true"
                                                [separateDialCode]="separateDialCode"
                                                [numberFormat]="PhoneNumberFormat.National" name="phone"
                                                formControlName="related_phone_ESN">
                                            </ngx-intl-tel-input>

                                        </div>
                                        <div
                                            *ngIf="formclient.controls['related_phone_ESN']?.invalid && formclient.controls['related_phone_ESN']?.touched">
                                            <span class="text-danger">Numéro de téléphone est
                                                invalide</span>
                                        </div>
                                    </div>
                                </div>
                                 <div class="row">
                                <div class="actions">
                                    <a class="annuler" routerLink="/nos-clients/liste" style="cursor: pointer;">Annuler</a>
                                    <!-- <a  class="confirmer"[disabled]="clientSearchErrorMessage === 'client already associated to this company'" (click)="createClient()">Confirmer</a> -->
                                    <button class="confirmer"
                                        (click)="updateClient()">Confirmer</button>
                                </div>
                            </div>
                            </div>
                           
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
